// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order_details .order-details-info {
  background: transparent;
  border: none;
}
.order_details .order-details-info .ant-card-head {
  padding: 0;
}
.order_details .order-details-info .ant-card-head .ant-card-head-title {
  font-size: 28px;
}
.order_details .order-details-info .ant-card-head .ant-card-head-title .icon {
  font-weight: 800;
}
.order_details .order-details-info .ant-card-body {
  padding: 0px;
}
.order_details .delivery-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
.order_details .delivery-info span {
  display: inline-block;
  width: 90%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.order_details .order_info .ant-card {
  overflow: hidden;
}
.order_details .order-card-title {
  font-size: 1.2rem;
  font-weight: bold;
}
.order_details .order-card-icon {
  font-size: 2rem;
}
.order_details .customer-info-container {
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.order_details .customer-info-container .customer-info-detail {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  row-gap: 1rem;
}
@media screen and (max-width: 768px) {
  .order_details .customer-info-container .customer-info-detail {
    grid-template-columns: 1fr;
  }
}
.order_details .order-table .ant-card-body {
  padding: 0 !important;
}
.order_details .order-table__summary {
  padding: 20px;
}
.order_details .customer-name {
  font-size: 1.2rem;
}
.order_details .customer-info {
  display: flex;
  flex-direction: column;
}
.order_details .customer-info .title {
  font-weight: bold;
}
.order_details .customer-info .description {
  display: inline-flex;
  text-overflow: ellipsis;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;
}
.order_details .order-message {
  width: 70%;
  -webkit-border-radius: 15px;
  -webkit-border-bottom-left-radius: 0;
  -moz-border-radius: 15px;
  -moz-border-radius-bottomleft: 0;
  border-radius: 15px;
  border-bottom-left-radius: 0;
  background-color: var(--grey);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
}
.order_details .order-message .message {
  font-size: 1rem;
}
.order_details .order-message .date {
  font-size: 0.7rem;
}

.bonus {
  color: var(--dark-red);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/order-details.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,YAAA;AAAJ;AACI;EACE,UAAA;AACN;AAAM;EACE,eAAA;AAER;AADQ;EACE,gBAAA;AAGV;AACI;EACE,YAAA;AACN;AAGE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAEI;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;AAAN;AAII;EACE,gBAAA;AAFN;AAME;EACE,iBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,eAAA;AALJ;AAQE;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AANJ;AAQI;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;AANN;AAQM;EANF;IAOI,0BAAA;EALN;AACF;AAUI;EACE,qBAAA;AARN;AAWI;EACE,aAAA;AATN;AAaE;EACE,iBAAA;AAXJ;AAcE;EACE,aAAA;EACA,sBAAA;AAZJ;AAcI;EACE,iBAAA;AAZN;AAeI;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAbN;AAiBE;EACE,UAAA;EACA,2BAAA;EACA,oCAAA;EACA,wBAAA;EACA,gCAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;AAfJ;AAiBI;EACE,eAAA;AAfN;AAkBI;EACE,iBAAA;AAhBN;;AAsBA;EACE,sBAAA;AAnBF","sourcesContent":[".order_details {\n  .order-details-info {\n    background: transparent;\n    border: none;\n    .ant-card-head {\n      padding: 0;\n      .ant-card-head-title {\n        font-size: 28px;\n        .icon {\n          font-weight: 800;\n        }\n      }\n    }\n    .ant-card-body {\n      padding: 0px;\n    }\n  }\n\n  .delivery-info {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n    span {\n      display: inline-block;\n      width: 90%;\n      white-space: nowrap;\n      overflow: hidden !important;\n      text-overflow: ellipsis;\n    }\n  }\n  .order_info {\n    .ant-card {\n      overflow: hidden;\n    }\n  }\n\n  .order-card-title {\n    font-size: 1.2rem;\n    font-weight: bold;\n  }\n\n  .order-card-icon {\n    font-size: 2rem;\n  }\n\n  .customer-info-container {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n\n    .customer-info-detail {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      width: 100%;\n      row-gap: 1rem;\n\n      @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n  }\n\n  .order-table {\n    .ant-card-body {\n      padding: 0 !important;\n    }\n\n    &__summary {\n      padding: 20px;\n    }\n  }\n\n  .customer-name {\n    font-size: 1.2rem;\n  }\n\n  .customer-info {\n    display: flex;\n    flex-direction: column;\n\n    .title {\n      font-weight: bold;\n    }\n\n    .description {\n      display: inline-flex;\n      text-overflow: ellipsis;\n      align-items: center;\n      gap: 5px;\n      flex-wrap: nowrap;\n    }\n  }\n\n  .order-message {\n    width: 70%;\n    -webkit-border-radius: 15px;\n    -webkit-border-bottom-left-radius: 0;\n    -moz-border-radius: 15px;\n    -moz-border-radius-bottomleft: 0;\n    border-radius: 15px;\n    border-bottom-left-radius: 0;\n    background-color: var(--grey);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 10px;\n\n    .message {\n      font-size: 1rem;\n    }\n\n    .date {\n      font-size: 0.7rem;\n    }\n  }\n\n}\n\n.bonus {\n  color: var(--dark-red)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
